export const PERMS = {
    READ: 'tax_rates.read',
    UPDATE: 'tax_rates.update',
    DELETE: 'tax_rates.delete',
    CREATE: 'tax_rates.create',
    EXPORT: 'tax_rates.export',
}
